import React, { useState, useEffect, useRef, createContext } from 'react';
import { useHistory } from "react-router-dom";

import { TourProvider } from '@reactour/tour';
import { useTour } from '@reactour/tour'
import Grid from '@material-ui/core/Grid';
import { useTheme } from '@material-ui/styles';
import Button from '@material-ui/core/Button';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

import logo from '../logo.png';

import Chrome from './ProductImages/CompanyIcons/Chrome.png';
import Edge from './ProductImages/CompanyIcons/Edge.png';
import Firefox from './ProductImages/CompanyIcons/Firefox.png';
import Google from './ProductImages/CompanyIcons/Google.png';
import YahooSearch from './ProductImages/CompanyIcons/YahooSearch.png';
import Bing from './ProductImages/CompanyIcons/Bing.png';
import DuckDuckGo from './ProductImages/CompanyIcons/DuckDuckGo.png';
import Facebook from './ProductImages/CompanyIcons/Facebook.png';
import Linkedin from './ProductImages/CompanyIcons/Linkedin.png';
import Twitter from './ProductImages/CompanyIcons/Twitter.png';
import Reddit from './ProductImages/CompanyIcons/Reddit.png';
import Quora from './ProductImages/CompanyIcons/Quora.png';

import Gmail from './ProductImages/CompanyIcons/Gmail.png';
import Outlook from './ProductImages/CompanyIcons/Outlook.png';
import Yahoo from './ProductImages/CompanyIcons/Yahoo.png';
import FacebookMessenger from './ProductImages/CompanyIcons/FacebookMessenger.png';
import Slack from './ProductImages/CompanyIcons/Slack.png';

import fireFoxGif from './ProductGifs/Firefox and DuckDuckGo.mp4';
import yellowOutlookBrowser from './ProductGifs/Yellow_Email.mp4';
import PhishCloud_Slack_Demo from './ProductGifs/PhishCloud_Slack_Demo.mp4';
import grayOutline from './ProductGifs/grayOutline.gif'
import rygHighlight from './ProductGifs/rygShoot.gif';
import rightClick from './ProductGifs/rightClickUpdate.gif';

import './ProductTourSlides.css';



const ProductTourSlides = (props) => {

    //const [isTourOpen, setIsTourOpen] = useState(true);
    const { isOpen, currentStep, setIsOpen, setCurrentStep } = useTour()
    const [steps, setSteps] = useState()
    // const toggleTour = () => {
    //     setIsTourOpen(!props.isTourOpen)
    // }

    useEffect(() => {
        if (props.demoType === 'userFlow') {
            setSteps(slides.userFlow)
            setIsOpen(true)
        } else if (props.demoType === 'adminConfigs') {
            setSteps(slides.adminConfigs)
            setIsOpen(true)
        } else if (props.demoType === 'userConfigs') {
            setSteps(slides.userConfigs)
            setIsOpen(true)
        }


    }, [props.demoType]);

    // useEffect(() => {

    //    // if (props.isTourOpen) { 
    //         setIsOpen(true) 
    //         console.log(isOpen)
    //    // }

    // }, []);

    const theme = useTheme();

    const backgroundColor = theme.palette.type === 'dark' ? '#424242' : 'white'
    const fontColor = theme.palette.type === 'dark' ? 'white' : 'black'
    const fontSize = '1rem'



    const slides = {
        userFlow: [
            {
                content: () => {
                    const userFlowControls = document.querySelector('[data-tour-elem="controls"]');
                    if (userFlowControls) userFlowControls.classList.add("user-flow-controls");
                    return (
                        <div className="intro-card">
                            <h4 className="center-text">Welcome to PhishCloud! <img src={logo} style={{ width: '50px', height: '50px' }} /></h4>
                            <div className="vertical-center welcome-horizontal-center center-text">
                                <br />
                    PhishCloud protects you from phishing attacks in email, web browsers, social media and messaging applications.
                    While we complete the installation of PhishCloud, let’s take a look at how we protect you while you work.
                    </div>
                        </div>)
                },
                style: {
                    minWidth: '700px',
                    minHeight: '566.95px',
                    // minWidth: "96vw",
                    // height: "90vh",
                    color: fontColor,
                    backgroundColor: backgroundColor,
                    fontSize: fontSize
                }
            },
            {
                selector: '[data-tut="reactour__logo"]',
                content: () => (
                    <div className="intro-card">
                        <h4 style={{ height: '50px' }} className="center-text">Privacy</h4>
                        <div className="vertical-center horizontal-center center-text" >

                            <br />
                  We take your privacy seriously. More messaging to come.
                    </div>
                    </div>
                ),
                style: {
                    minWidth: '700px',
                    maxHeight: '700px',
                    // minWidth: "96vw",
                    // height: "90vh",
                    color: fontColor,
                    backgroundColor: backgroundColor,
                    fontSize: fontSize
                }
            },
            {
                selector: '[data-tut="reactour__style"]',
                content: () => (
                    <div className="intro-card">
                        <h4 style={{ height: '50px' }} className="center-text">Stop Light Bars</h4>
                        <div className="vertical-center">

                            <Grid container
                                direction="row"
                                justify="space-around"
                                alignItems="center"
                                spacing={2}>
                                <Grid item xs={7}>

                                    <img src={rygHighlight} style={{ width: "100%" }} />

                                </Grid>
                                <Grid item xs={4}>
                                    PhishCloud scans every URL (link) and provides “traffic light” style highlighting -
                                    red for malicious, yellow for suspicious, and green for safe - so you know what is safe and what is not.
          <br />
                                    <br />
          Look for these highlights in email, search engines, web browsers, social media and messaging applications.
            They will help you make the right decisions on clickable links.
                          </Grid>
                            </Grid>
                        </div>
                    </div>
                ),
                style: {
                    minWidth: "86vw",
                    height: "80vh",
                    color: fontColor,
                    backgroundColor: backgroundColor,
                    fontSize: fontSize
                }
            },
            {
                selector: '[data-tut="reactour__copy"]',
                content: () => (
                    <div className="intro-card">
                        <h4 style={{ height: '50px' }} className="center-text">Gray Bars</h4>
                        <div className="vertical-center">


                            <Grid container
                                direction="row"
                                justify="space-around"
                                alignItems="center"
                                spacing={2}>
                                <Grid item xs={4}>
                                    You may, from time to time, see a Gray Highlight around content, rather than Red, Yellow or Green.  This simply means that the URL is under review by the PhishCloud engines.
                                    Within an average of 1.5 seconds you should get a Red, Yellow, or Green response.
          </Grid>
                                <Grid item xs={7}>
                                    <img src={grayOutline} style={{ width: "100%" }} />
                                </Grid>
                            </Grid>
                        </div>
                    </div>),
                style: {
                    minWidth: "86vw",
                    height: "80vh",
                    color: fontColor,
                    backgroundColor: backgroundColor,
                    fontSize: fontSize
                }
            },
            {
                selector: '[data-tut="reactour__style"]',
                content: () => (
                    <div className="intro-card">
                        <h4 style={{ height: '50px' }} className="center-text">Right-Click / User Feedback</h4>
                        <div className="vertical-center">

                            <Grid container
                                direction="row"
                                justify="space-around"
                                alignItems="center"
                                spacing={2}>
                                <Grid item xs={7}>

                                    <img src={rightClick} style={{ width: "100%" }} />

                                </Grid>
                                <Grid item xs={4}>
                                    The internet is a big place!  PhishCloud automatically scans some sites, but not everywhere.
                                    If you ever want to be sure about a link, right-click on it and click "check link safety".
                                    <br />
                                    <br />
                                    We'll scan the link and give you details on that link in a pop-up screen.
                                    You can also send us immediate feedback on whether you agree or disagree with our safety rating using the thumbs up/down buttons.


                            </Grid>
                            </Grid>
                        </div>
                    </div>
                ),
                style: {
                    // minWidth: "96vw",
                    // height: "90vh",
                    minWidth: "86vw",
                    height: "80vh",
                    color: fontColor,
                    backgroundColor: backgroundColor,
                    fontSize: fontSize
                }
            },
            {
                selector: '[data-tut="reactour__style"]',
                content: () => (
                    <div className="intro-card">
                        <h4 style={{ height: '50px' }} className="center-text">Where does PhishCloud protect you?</h4>
                        <div className="vertical-center horizontal-center">

                            <Grid>
                                Browsers:
                        <br />
                                <br />
                                <Grid container
                                    direction="row"
                                    justify="center"
                                    alignItems="center"
                                    spacing={7}>
                                    <Grid item><img src={Edge}></img></Grid>
                                    <Grid item><img src={Chrome}></img></Grid>
                                    <Grid item><img src={Firefox}></img></Grid>
                                </Grid>
                                <br />

                    Search Engines:
                        <br />
                                <br />
                                <Grid container
                                    direction="row"
                                    justify="center"
                                    alignItems="center"
                                    spacing={7}>
                                    <Grid item><img src={Google} /></Grid>
                                    <Grid item><img style={{ width: '43px', height: '43px' }} src={Bing} /></Grid>
                                    <Grid item><img style={{ width: '40px', height: '40px' }} src={DuckDuckGo} /></Grid>
                                    <Grid item><img style={{ width: '40px', height: '40px' }} src={YahooSearch} /></Grid>
                                </Grid>
                                <br />

                    Social Media:
                        <br />
                                <br />
                                <Grid container
                                    direction="row"
                                    justify="center"
                                    alignItems="center"
                                    spacing={7}>
                                    <Grid item><img src={Facebook} /></Grid>
                                    <Grid item><img src={Linkedin} /></Grid>
                                    <Grid item><img src={Twitter} /></Grid>
                                    <Grid item><img src={Reddit} /></Grid>
                                    <Grid item><img src={Quora} /></Grid>
                                </Grid>
                                <br />

                        Email and Chat Applications:
                        <br />
                                <br />
                                <Grid container
                                    direction="row"
                                    justify="center"
                                    alignItems="center"
                                    spacing={7}>
                                    <Grid item><img src={Gmail}></img></Grid>
                                    <Grid item><img src={Outlook}></img></Grid>
                                    <Grid item><img src={Yahoo}></img></Grid>
                                    <Grid item><img style={{ width: '40px', height: '40px' }} src={FacebookMessenger} ></img></Grid>
                                    <Grid item><img src={Slack}></img></Grid>
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                ),
                style: {
                    // minWidth: "96vw",
                    // height: "90vh",
                    maxWidth: "86vw",
                    minWidth: '700px',
                    height: "80vh",
                    color: fontColor,
                    backgroundColor: backgroundColor,
                    fontSize: fontSize
                }
            },

            {
                selector: '[data-tut="reactour__style"]',
                content: () => (
                    <div className="intro-card">
                        <h4 style={{ height: '50px' }} className="center-text">Feedback</h4>
                        <div className="vertical-center">

                            We value your feedback as we work to provide the best phishing protection available today.  Please email your feedback/suggestions to feedback@phishcloud.com.
                        <br />
                            <br />
                    Thank you for helping us continuously improve our service.
                        <br />
                            <br />
                    Enjoy PhishCloud!

                  If you have suggestions for sites that you'd like PhishCloud to auto-scan or any feedback that you think would help us
                  be better, please email us your thoughts at <a href="mailto:feedback@phishcloud.com">feedback@phishcloud.com</a>, and thank you for helping to make us better!
                    </div>
                    </div>
                ),
                style: {
                    minWidth: '700px',
                    maxHeight: '700px',
                    // minWidth: "96vw",
                    // height: "90vh",
                    color: fontColor,
                    backgroundColor: backgroundColor,
                    fontSize: fontSize
                }
            },
        ],
        userConfigs: [
            {
                selector: '[data-tut="reactour__state"]',
                content: () => {
                    const nextArrow = document.querySelector('[data-tour-elem="right-arrow"]');
                    if (nextArrow) nextArrow.onclick = () => props.history.push('/Dashboard/History');
                    return (
                        <div className="intro-card">
                            <h4>Intro</h4>
                            <br />
                        Now that you know how PhishCloud helps you identify and prevent phishing, let’s take a look at your personal portal.
                            <br />
                            <br />
                        First, let’s explore your history page.  PhishCloud takes *your* privacy extremely seriously!
                        The information on this page only you can see.  No admin or developers have access to your browsing history.
                        The only time we’ll share details with anyone except you is when we detect a malicious event has occurred and
                        we’ll generate an alert for the Security team to notify and help you.

                        </div>
                    )
                },
                style: {
                    minWidth: '700px',
                    maxHeight: '700px',
                    color: fontColor,
                    backgroundColor: backgroundColor,
                    fontSize: fontSize
                }
            },
            {
                selector: '.selector-bar-metrics',
                position: [20, 1200],
                content: () => {
                    const nextArrow = document.querySelector('[data-tour-elem="right-arrow"]');
                    if (nextArrow) nextArrow.onclick = () => console.log('.')
                    return (
                        <div className="intro-card">
                            <h4>User History</h4>
                            <br />
                        At the top of the page you’ll see multiple items about your activity,
                        including which computer you were on when an event happened.
                        Each person can use PhishCloud on up to 5 devices,
                        so feel free to install us on other devices for complete and private protection.

                        </div>
                    )
                },
                style: {
                    // minWidth: '700px',
                    // maxHeight: '700px',
                    color: fontColor,
                    backgroundColor: backgroundColor,
                    fontSize: fontSize
                }
            },
            {
                selector: '.selector-link-history-table',
                content: () => (
                    <div className="intro-card">
                        <h4>User History</h4>
                        <br />
                        The last 250 links that you’ve seen will appear here.
                        You’ll be surprised at how many links you see in a day!

                    </div>
                ),
                style: {
                    // minWidth: '700px',
                    // maxHeight: '700px',
                    color: fontColor,
                    backgroundColor: backgroundColor,
                    fontSize: fontSize
                }
            },
            {
                selector: '.selector-news',
                position: 'left',
                content: () => (
                    <div className="intro-card">
                        <h4>User History</h4>
                        <br />
                        We will keep you up to date with some relevant news in the security world - check in often to see what’s happening.

                    </div>
                ),
                style: {
                    // minWidth: '700px',
                    // maxHeight: '700px',
                    color: fontColor,
                    backgroundColor: backgroundColor,
                    fontSize: fontSize
                }
            },
            {
                selector: '.selector-training',
                content: () => {
                    const nextArrow = document.querySelector('[data-tour-elem="right-arrow"]');
                    if (nextArrow) nextArrow.onclick = () => props.history.push('/Dashboard/Configuration');

                    return (
                        <div className="intro-card">
                            <h4>User History</h4>
                            <br />
                    Your training dashboard will help you stay current on training and we will suggest videos for you based on the types of malicious links you find on the internet.

                        </div>
                    )
                },
                style: {
                    // minWidth: '700px',
                    // maxHeight: '700px',
                    color: fontColor,
                    backgroundColor: backgroundColor,
                    fontSize: fontSize
                }
            },
            {
                selector: '.selector-website-list',
                content: () => {
                    const nextArrow = document.querySelector('[data-tour-elem="right-arrow"]');
                    if (nextArrow) nextArrow.onclick = () => console.log(".")
                    const previousArrow = document.querySelector('[data-tour-elem="left-arrow"]');
                    if (previousArrow) previousArrow.onclick = () => props.history.push('/Dashboard/History');
                    return (
                        <div className="intro-card">
                            <h4>User Configs</h4>
                            <br />
                    In the User Configuration section, you can see which sites we will auto-scan for you.
                    These are the sites where you will see the red/yellow/green bubbles as you navigate with your mouse.  Any other site, if you have a question about a link, just right-click and check the link.

                        </div>
                    )
                },
                style: {
                    minWidth: '700px',
                    maxHeight: '700px',
                    color: fontColor,
                    backgroundColor: backgroundColor,
                    fontSize: fontSize
                }
            },
            {
                selector: '.selector-darkMode-toggle',

                content: () => {
                    const previousArrow = document.querySelector('[data-tour-elem="left-arrow"]');
                    if (previousArrow) previousArrow.onclick = () => console.log(".")

                    const element = document.getElementById('display-switches-rectangle');
                    const elementRect = element.getBoundingClientRect();
                    const absoluteElementTop = elementRect.top + window.pageYOffset;
                    const middle = absoluteElementTop - (window.innerHeight / 2);
                    window.scrollTo(0, middle);


                    return (
                        <div className="intro-card">
                            <h4>User Configs</h4>
                            <br />
                    You can also go into dark mode!

                        </div>
                    )
                },
                style: {
                    minWidth: '700px',
                    maxHeight: '700px',
                    color: fontColor,
                    backgroundColor: backgroundColor,
                    fontSize: fontSize
                }
            },
            {
                selector: '[data-tut="reactour__state"]',
                content: () => (
                    <div className="intro-card">
                        <h4>User Configs</h4>
                        <br />
                    If you have any questions or suggestions about sites that you’d like PhishCloud to automatically scan,
                    let us know at <a href="mailto:info@phishcloud.com">info@phishcloud.com</a>.

                    </div>
                ),
                style: {
                    minWidth: '700px',
                    maxHeight: '700px',
                    color: fontColor,
                    backgroundColor: backgroundColor,
                    fontSize: fontSize
                }
            },
        ],
        adminConfigs: [{
            selector: '[data-tut="reactour__state"]',
            content: () => {
                const nextArrow = document.querySelector('[data-tour-elem="right-arrow"]');
                if (nextArrow) nextArrow.onclick = () => props.history.push('/Dashboard/AdminConfiguration');
                return (
                    <div className="intro-card">
                        <h4>Welcome to PhishCloud</h4>
                        <br />
                    As an administrator of your organization, you have many responsibilities.
                    PhishCloud is constantly working to automate as many of those as possible and only bring items
                    to you that need your attention.

                    Let’s walk through configuring your account.  This should take about 10 minutes.

                    </div>
                )
            },
            style: {
                color: fontColor,
                backgroundColor: backgroundColor,
                fontSize: fontSize
            }

        },
        {
            selector: '#selector-confidence-level',
            content: () => {
                const nextArrow = document.querySelector('[data-tour-elem="right-arrow"]');
                if (nextArrow) nextArrow.onclick = () => console.log(".");
                return (
                    <div className="intro-card">
                        <h4>Admin Config</h4>
                        <br />

                    Confidence Level is how PhishCloud measures the safety of URLs.
                    We use PhishCloud AI, 3rd party sources and live analysts to determine the relative safety of a link.
                    All of that information becomes a score between 0 (most unsafe) and 100 (safest).
                    We allow you to choose how conservative or risky you’d like to be for your organization.
                        <br />
                        <br />
                    Typically, links that have 2 or more votes of confidence as being safe will score 72 or higher.
                    Links that have 1 or more malicious reports will score under 40.

                    </div>
                )
            },
            style: {
                color: fontColor,
                backgroundColor: backgroundColor,
                fontSize: fontSize
            }
        },
        {
            selector: '.selector-notifications',
            content: () => {
                //         const nextArrow = document.querySelector('[data-tour-elem="right-arrow"]');
                // if (nextArrow) nextArrow.onclick = () => props.history.push('/Dashboard/LinkSafetyRules');
                return (
                    <div className="intro-card">
                        <h4>Admin Config</h4>
                        <br />
                    If one of the people in your organization clicks on a yellow (unknown) or red (unsafe) link,
                    that will generate an alert.  Instead of creating a task for yourself, let us tell you when that happens.
                    You can sign up multiple emails or phone numbers to receive notifications when an alert happens.
                        <br />
                        <br />
                    You can set them up now or return to this page and set them later.
                    </div>
                )
            },
            style: {
                color: fontColor,
                backgroundColor: backgroundColor,
                fontSize: fontSize
            }
            //action: () => props.history.push('/Dashboard/AdminConfiguration')
        },
        {
            selector: '.selector-save-admin-configs',
            content: () => {
                const nextArrow = document.querySelector('[data-tour-elem="right-arrow"]');
                if (nextArrow) nextArrow.onclick = () => props.history.push('/Dashboard/LinkSafetyRules');
                return (
                    <div className="intro-card">
                        <h4>Admin Config</h4>
                        <br />
                        Click here to save your settings
                    </div>
                )
            },
            style: {
                color: fontColor,
                backgroundColor: backgroundColor,
                fontSize: fontSize
            }
        },
        {
            selector: '.selector-linkSafetyRules',
            position: [20, 20],
            content: () => {
                const nextArrow = document.querySelector('[data-tour-elem="right-arrow"]');
                const previousArrow = document.querySelector('[data-tour-elem="left-arrow"]');
                if (nextArrow) nextArrow.onclick = () => props.history.push('/Dashboard/UserManagement');
                if (previousArrow) previousArrow.onclick = () => props.history.push('/Dashboard/AdminConfiguration');

                return (
                    <div className="intro-card">
                        <h4>Link Safety Rules</h4>
                        <br />
                        The link safety rules are like a firewall that lives with the user in their browser.
                        If you have known malicious sites that you’d like to always flag as red/be reported when users visit or known safe sites,
                        like your intranet or company dropbox locations, add them here.
                        <br />
                        <br />
                        If you have a large list of sites that you’d like to have added for you,
                        just send your list in an email to support@phishcloud.com and we’d be happy to help!

                    </div>
                )
            },
            style: {
                color: fontColor,
                backgroundColor: backgroundColor,
                fontSize: fontSize
            }
        },
        {
            selector: '.selector-linkSafetyRules',
            position: [20, 20],
            content: () => {
                const nextArrow = document.querySelector('[data-tour-elem="right-arrow"]');
                const previousArrow = document.querySelector('[data-tour-elem="left-arrow"]');
                if (nextArrow) nextArrow.onclick = () => props.history.push('/Dashboard/UserManagement');
                if (previousArrow) previousArrow.onclick = () => props.history.push('/Dashboard/AdminConfiguration');

                return (
                    <div className="intro-card">
                        <h4>Link Safety Rules</h4>
                        <br />
                       Would you like to walk through setting a link safety rule?
                        <br />
                        <br />
                        <Button></Button>

                    </div>
                )
            },
            style: {
                color: fontColor,
                backgroundColor: backgroundColor,
                fontSize: fontSize
            }
        },
        {
            selector: '.selector-userManagement',
            position: [20, 20],
            content: () => {
                const nextArrow = document.querySelector('[data-tour-elem="right-arrow"]');
                const previousArrow = document.querySelector('[data-tour-elem="left-arrow"]');
                if (nextArrow) nextArrow.onclick = () => props.history.push('/Dashboard/CompanyOverviewAccountAdmin');
                if (previousArrow) previousArrow.onclick = () => props.history.push('/Dashboard/LinkSafetyRules');

                return (
                    <div className="intro-card">
                        <h4>User Management</h4>
                        <br />
                    This is the User Management portal.
                    You can add people one-by-one or use the components from the Downloads page to do an administrated group
                    policy installation.
                        <br />
                        <br />
                    Use the “add single user” or “add multiple users” buttons to start adding more people.
                    If you have a lot of users to add, you can use a CSV file to upload those users to your account from the “add multiple users” option.

                    </div>
                )
            },
            style: {
                color: fontColor,
                backgroundColor: backgroundColor,
                fontSize: fontSize
            }
        },
        {
            selector: '[data-tut="reactour__state"]',
            content: () => {
                const nextArrow = document.querySelector('[data-tour-elem="right-arrow"]');
                const previousArrow = document.querySelector('[data-tour-elem="left-arrow"]');
                if (nextArrow) nextArrow.onclick = () => console.log(".")
                if (previousArrow) previousArrow.onclick = () => props.history.push('/Dashboard/UserManagement');

                return (
                    <div className="intro-card">
                        <h4>Company Overview</h4>
                        <br />
                    Company Overview is a great place to come to look at your organization at a glance!
                    </div>
                )
            },
            style: {
                color: fontColor,
                backgroundColor: backgroundColor,
                fontSize: fontSize
            }
        },
        {
            selector: '.selector-box-statistics',
            content: () => {
                const nextArrow = document.querySelector('[data-tour-elem="right-arrow"]');
                const previousArrow = document.querySelector('[data-tour-elem="left-arrow"]');
                if (nextArrow) nextArrow.onclick = () => console.log(".")
                if (previousArrow) previousArrow.onclick = () => console.log(".")

                return (
                    <div className="intro-card">
                        <h4>Company Overview</h4>
                        <br />
                    See how many of your users have been actively using PhishCloud in the last 24 hours and what your
                    organization risk level is based on user activity.

                    </div>
                )
            },
            style: {
                color: fontColor,
                backgroundColor: backgroundColor,
                fontSize: fontSize
            },
        },
        {
            selector: '.selector-threat-model',
            content: () => (
                <div className="intro-card">
                    <h4>Company Overview</h4>
                    <br />
                    See how many unknown/unsafe links your organization is seeing in social media, search engines and emails!

                </div>
            ),
            style: {
                color: fontColor,
                backgroundColor: backgroundColor,
                fontSize: fontSize
            }
        },

        {
            selector: '.selector-alert-chart',
            content: () => {
                const nextArrow = document.querySelector('[data-tour-elem="right-arrow"]');
                const previousArrow = document.querySelector('[data-tour-elem="left-arrow"]');
                if (nextArrow) nextArrow.onclick = () => props.history.push('/Dashboard/Alerts');

                return (
                    <div className="intro-card">
                        <h4>Company Overview</h4>
                        <br />
                    See new alerts over time and access the alerts page!

                    </div>
                )
            },
            style: {
                color: fontColor,
                backgroundColor: backgroundColor,
                fontSize: fontSize
            },
        },
        {
            selector: '.selector-alerts',
            position: [20, 20],
            content: () => {
                const nextArrow = document.querySelector('[data-tour-elem="right-arrow"]');
                const previousArrow = document.querySelector('[data-tour-elem="left-arrow"]');
                if (nextArrow) nextArrow.onclick = () => console.log(".");
                if (previousArrow) previousArrow.onclick = () => props.history.push('/Dashboard/CompanyOverviewAccountAdmin')

                return (
                    <div className="intro-card">
                        <h4>Alerts</h4>
                        <br />
                    When a user clicks on a yellow or red link, they will automatically become alerts.
                    Medium severity (yellow link click) or High (red link click).

                    </div>
                )
            },
            style: {
                color: fontColor,
                backgroundColor: backgroundColor,
                fontSize: fontSize
            },
        },
        {
            selector: 'selector-alert-details',
            content: () => {
                const nextArrow = document.querySelector('[data-tour-elem="right-arrow"]');
                const previousArrow = document.querySelector('[data-tour-elem="left-arrow"]');
                if (nextArrow) nextArrow.onclick = () => props.history.push('/Dashboard/AnalyzeLinkAdmin?pad=&link=https%3A%2F%2Fwww.google.com%2F');
                if (previousArrow) previousArrow.onclick = () => props.history.push('/Dashboard/Alerts');

                return (
                    <div className="intro-card">
                        <h4>Alerts</h4>
                        <br />
                    ||| [Highlight detail page - see note in google doc regarding this] |||
                        <br />
                        <br />
                    When you look at the details on an alert, you can see attribution details [highlight attribution] for follow up,
                    and you have some quick actions to add a link safety rule or analyze the link more closely!

                    </div>
                )
            },
            style: {
                color: fontColor,
                backgroundColor: backgroundColor,
                fontSize: fontSize
            },
        },
        {
            selector: '[data-tut="reactour__state"]',
            content: () => {
                const nextArrow = document.querySelector('[data-tour-elem="right-arrow"]');
                const previousArrow = document.querySelector('[data-tour-elem="left-arrow"]');
                if (nextArrow) nextArrow.onclick = () => console.log(".");
                if (previousArrow) previousArrow.onclick = () => props.history.push('/Dashboard/Alerts');


                return (
                    <div className="intro-card">
                        <h4>Link Analysis</h4>
                        <br />
                    You can get to the link analysis page from multiple locations:
                    the menu bar, history page or alert detail page.
                    As an administrator, you can see more information than your users.
                    </div>
                )
            },
            style: {
                color: fontColor,
                backgroundColor: backgroundColor,
                fontSize: fontSize
            },
        },
        {
            selector: '.selector-global-company-stats',
            content: () => {
                const nextArrow = document.querySelector('[data-tour-elem="right-arrow"]');
                const previousArrow = document.querySelector('[data-tour-elem="left-arrow"]');
                if (nextArrow) nextArrow.onclick = () => console.log(".");
                if (previousArrow) previousArrow.onclick = () => console.log(".");

                return (
                    <div className="intro-card">
                        <h4>Link Analysis</h4>
                        <br />
You can see how many users in your company have seen and/or clicked on this link.
You can also compare that to the rest of the PhishCloud network.

                    </div>
                )
            },
            style: {
                color: fontColor,
                backgroundColor: backgroundColor,
                fontSize: fontSize
            },
        },
        {
            selector: '.selector-DNS',
            content: () => (
                <div className="intro-card">
                    <h4>Link Analysis</h4>
                    <br />
                    If DNS information is available for this domain, we will supply it here.

                </div>
            ),
            style: {
                color: fontColor,
                backgroundColor: backgroundColor,
                fontSize: fontSize
            }
        },
        {
            selector: '.selector-redirect-chain',
            content: () => (
                <div className="intro-card">
                    <h4>Link Analysis</h4>
                    <br />
                    The re-direct chain will show you any re-directs from this link and where you will actually land if you had clicked
                     on this link.

                </div>
            ),
            style: {
                color: fontColor,
                backgroundColor: backgroundColor,
                fontSize: fontSize
            }
        },
        {
            selector: '.selector-redirect-chain',
            content: () => (
                <div className="intro-card">
                    <h4>End of Tour/Feedback</h4>
                    <br />
                    Thank you for completing the admin tour!
                    (Better messaging needed)
                    <br />
                    <br />
                    We value your feedback as we work to provide the best phishing protection available today.  Please email your feedback/suggestions to feedback@phishcloud.com.
                    <br />
                    <br />
                    Thank you for helping us continuously improve our service.
                    <br />
                    <br />
                    Enjoy PhishCloud!

                  If you have suggestions for sites that you'd like PhishCloud to auto-scan or any feedback that you think would help us
                  be better, please email us your thoughts at <a href="mailto:feedback@phishcloud.com">feedback@phishcloud.com</a>, and thank you for helping to make us better!
                </div>
            ),
            style: {
                color: fontColor,
                backgroundColor: backgroundColor,
                fontSize: fontSize
            }
        },
        ],
    }

    return (<div>
        {steps != undefined ?
            <TourProvider
                steps={steps}
                isOpen={true}
                // rounded={5}
                // disableKeyboardNavigation={true}
                // disableDotsNavigation={true}
                // scrollSmooth={true}
                // inViewThreshold={20}
                // //accentColor={}
                // onRequestClose={props.toggleTour}
                // prevButton={<Button><ArrowBackIcon />    Back</Button>}
                // nextButton={<Button>Next    <ArrowForwardIcon /></Button>}
                // lastStepNextButton={<Button>Tour Complete!</Button>}
            > {props.children} </TourProvider> : null}
    </div>
    );

}; export default ProductTourSlides





// {
//     selector: '[data-tut="reactour__style"]',
//     content: () => (
//         <div className="intro-card">
//              <h4 style={{ height: '50px'}} className="center-text">Search Engines</h4>
//         <div className="vertical-center horizontal-center center-text">

//             <br />
//         Regardless of what your favorite search engine is, PhishCloud has you covered.
//         We currently auto-scan the following search engines:
//             <br />
//             <br />
//             <Grid container
//                 direction="row"
//                 justify="center"
//                 alignItems="center"
//                 spacing={7}>
//                 <Grid item><img src={Google} /></Grid>
//                 <Grid item><img style={{ width: '43px', height: '43px' }} src={Bing} /></Grid>
//                 <Grid item><img style={{ width: '40px', height: '40px' }} src={DuckDuckGo} /></Grid>
//                 <Grid item><img style={{ width: '40px', height: '40px' }} src={YahooSearch} /></Grid>
//             </Grid>
//         </div>
//         </div>
//     ),
//       style: {
//         // minWidth: "96vw",
//         // height: "90vh",
//         color: fontColor,
// backgroundColor: backgroundColor,
// fontSize: fontSize
//       }
// },
// {
//     selector: '[data-tut="reactour__style"]',
//     content: () => (
//         <div className="intro-card">
//             <h4 style={{  height: '50px'}} className="center-text">Social Media</h4>
//         <div className="vertical-center horizontal-center center-text">

//             <br />
//         Social Media is now the attack vector in 25% of phishing attacks.
//         We’ll help you stay safe in the following social media sites:
//             <br />
//             <br />
//             <Grid container
//                 direction="row"
//                 justify="center"
//                 alignItems="center"
//                 spacing={7}>
//                 <Grid item><img src={Facebook} /></Grid>
//                 <Grid item><img src={Linkedin} /></Grid>
//                 <Grid item><img src={Twitter} /></Grid>
//                 <Grid item><img src={Reddit} /></Grid>
//                 <Grid item><img src={Quora} /></Grid>
//             </Grid>
//         </div>
//         </div>
//     ),
//       style: {
//         // minWidth: "96vw",
//         // height: "90vh",
//         color: fontColor,
// backgroundColor: backgroundColor,
// fontSize: fontSize
//       }
// },
// {
//     selector: '[data-tut="reactour__style"]',
//     content: () => (
//         <div className="intro-card">
//              <h4 style={{ height: '50px'}} className="center-text">Browser Email/Chat</h4>
//         <div className="vertical-center horizontal-center center-text">

//         Communications tools are prime targets for phishing attacks.
//         PhishCloud will keep you safe while using the following email and chat applications:
//             <br />
//             <br />
//             <Grid container
//                 direction="row"
//                 justify="center"
//                 alignItems="center"
//                 spacing={7}>
//                 <Grid item><img src={Gmail}></img></Grid>
//                 <Grid item><img src={Outlook}></img></Grid>
//                 <Grid item><img src={Yahoo}></img></Grid>
//                 <Grid item><img style={{ width: '40px', height: '40px' }} src={FacebookMessenger} ></img></Grid>
//                 <Grid item><img src={Slack}></img></Grid>
//             </Grid>
//             </div>
//         </div>
//     ),
//       style: {
//         // minWidth: "96vw",
//         // height: "90vh",
//         color: fontColor,
// backgroundColor: backgroundColor,
// fontSize: fontSize
//       }
// },